/**
 * The differences between the questionnaire and the data.
 * On-demand check of whether a survey project's loaded data metadata (the uploaded datamap,
 * merged into the DQD) still matches its questionnaire. Read-only: nothing is recorded.
 * Authentication headers are handled automatically by the axios instance.
 */
import { AxiosInstance } from "axios"
import { DatamapDriftResponse } from "types/questionnaire.types"

/**
 * Checks whether the loaded data's metadata diverges from the questionnaire.
 *
 * @param axiosInstance - Authenticated axios instance
 * @param id - The project to check
 * @param owner - Owner hint (may be "" — resolved server-side for your own projects)
 * @returns { hasQnr, hasData, parseStatus, qnrMetadataHash, drift[] }
 */
export async function checkDatamapDrift(
  axiosInstance: AxiosInstance,
  id: string,
  owner: string
): Promise<DatamapDriftResponse> {
  return axiosInstance.get(
    `/datamap-drift-check?id=${encodeURIComponent(id)}&hint_owner=${encodeURIComponent(owner)}`
  )
}
